import type { HomeWidgetType } from '../../../components/widgets/homeWidgets/types';
import type { WidgetType } from '../types';

export const WIDGETS_GAP_MOBILE = 8;
export const WIDGETS_GAP_DESKTOP = 24;
export const WIDGET_SMALL_WIDTH = { mobile: 64, desktop: 76 };
export const WIDGET_SMALL_EXTENDED_WIDTH = { mobile: 60, desktop: 70 };
export const WIDGET_WIDE_WIDTH = { mobile: 202, desktop: 240 };
export const WIDGET_BINGO_LIVE_BUTTON_FONT_SIZE = {
  desktop: {
    max: 15,
    min: 13,
  },
  mobile: {
    max: 13,
    min: 11,
  },
};

export const HOME_WIDGET_WIDGET_TYPE_MAPPING: Partial<Record<WidgetType, HomeWidgetType>> = {
  bingo: 'Bingo',
  crownRips: 'CrownRips',
  cashOffer: 'CashOffer',
  coinBack: 'Coinback',
  message: 'Message',
  offer: 'Offer',
  rollingOffer: 'RollingOffer',
  quest: 'Quest',
  tournament: 'Tournament',
  championsTournament: 'Tournament',
  freeSpin: 'UnclaimedFreeSpin',
  miniGame: 'UnclaimedFreeSpin',
  upcomingDailyMission: 'UpcomingDailyMission',
  hammer: 'MetaGameEvent',
  prizeDrop: 'MetaGameEvent',
  roulette: 'MetaGameEvent',
  trail: 'MetaGameEvent',
  puzzle: 'MetaGameEvent',
  plinko: 'MetaGameEvent',
  snappyGift: 'SnappyGift',
  road: 'CrownRoad',
  challenge: 'Challenge',
  monetization: 'MonetizationEvent',
  upcomingMission: 'UpcomingMission',
  stampCard: 'StampCard',
};

export const FREE_SPIN_PROVIDERS = {
  RUBY_PLAY: 'RUBY_PLAY',
  PRAGMATIC_PLAY: 'PRAGMATIC_PLAY',
  BAROULETTA: 'Barouletta Gaming',
  SPINOMENAL: 'Spinomenal',
  MINIGAMES: 'Minigames',
};

export const BINGO_WIDGET_TIMER_BUFFER_MS = 3000;

export const STAMP_CARD_TEST_ID_PREFIX = 'stamp-card';
